import icannTrie from "../serialized-tries/icann.js";
import privateTrie from "../serialized-tries/private.js";

export { icannTrie, privateTrie };
